<template>
    <div class="row">
      <div class="col-md-12">
          <vuestic-widget headerText="Turmas">
          <div class="row">
            <div class="col-sm-12 col-lg-12 col-xl-12 d-flex justify-content-center">
              <table class="table table-responsive-sm">
                <thead>
                  <tr>
                    <th v-for="th in tableOptions.thead" scope="col" :key="th.id">{{th}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="aula in aulas.reposicoes"  :key="aula.id_aula_teorica"   v-show="isToday(aula.aula.inicio)">
                    <td> {{ aula.aula.turma.id_agrupamento }} </td>
                    <td> {{ aula.aula.inicio }} </td>
                    <td> {{ aula.aula.fim }} </td>
                    <td>
                      <button
                        :id="'push_' + aula.aula.turma.id_agrupamento"
                        v-if="getTime(aula.aula.turma.data_fim)"
                        title="Registre sua presença primeiro!"
                        class="btn btn-primary btn-with-icon rounded-icon btn-micro"
                        disabled="true"
                        @click="push(aula.aula.turma)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-video-camera"
                          style="font-size: 20px;padding-left: 3px;"
                        ></span>
                      </button>
                      <button
                        :id="'presenca_' + aula.aula.turma.id_agrupamento"
                        title="Registrar Presença"
                        class="btn btn-primary btn-with-icon rounded-icon btn-micro presenca"
                        @click="registrarPresenca(aula.aula.turma)"
                      >
                        <span
                          aria-hidden="true"
                          class="fa fa-user"
                          style="font-size: 20px;padding-left: 3px;"
                        ></span>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </vuestic-widget>
      </div>
      <vuestic-modal
          id="modal-photo"
          ref="photoModal"
          :cancelClass="'none'"
          :okClass="'none'"
          v-on:cancel="modalClosed"
        >
          <div class="col-sm-12 col-lg-12 col-xl-12">
            <div class="row justify-content-center text-center">
              <h1>Registre sua presença!</h1>
              <div class="col-md-6">
                <!-- <img id="mask" height="250" width="250" src="~assets/mask.png" /> -->
                <video id="player" width="250" height="250" autoplay ></video>
                <button @click="captureSnapshot" id="capture" class="btn btn-primary">Capturar</button>
              </div>
              <div class="col-md-6">
                <canvas id="snapshot" width="250" height="250"></canvas>
                <button @click="sendSnapshot" id="send" class="btn btn-primary" disabled>Enviar</button>
              </div>
            </div>
          </div>
        </vuestic-modal>
    </div>
</template>

<script>
import TurmasController from './TurmasController'
import * as spinners from 'epic-spinners'
import urlApi from '../../router/urlApi'
import TableAlunosTurma from './TableAlunosTurma'
import TableAlunosReposicao from './TableAlunosReposicao'
import TablePresencas from './TablePresencas'
import TableAulasTurma from './TableAulasTurma'
import DateIconGroup from '@/vuestic-theme/vuestic-components/vuestic-input/DateIconGroup'
import VuesticTabs from '@/vuestic-theme/vuestic-components/vuestic-tabs/VuesticTabs'
import utils from '../../services/utils'
import Webcam from 'webcam-easy'
import PresencaController from '../presenca/PresencaController'

  export default {
    name: 'Reposicao',
    components: {
      ...spinners,
      TableAlunosTurma,
      DateIconGroup,
      TableAulasTurma,
      TablePresencas,
      TableAlunosReposicao
    },
    data(){
      return {
        idAluno: localStorage.nome,
        url: urlApi + '/alunos',
        tableOptions: {
          thead: ['Agrupamento', 'Início', 'Fim', '-']
        },
        aulas: [],
        turma: [],
        id_role: localStorage.id_role,
      }
    },

    created(){
      this.getAulasReposicao();
    },

    methods:{

      isToday(data) {
          let ini = data.split(/[- :]/);
          let aula = new Date(new Date(ini[0], ini[1] -1, ini[2]));
          let now = new Date();
          let nowData = new Date(now.getFullYear(), now.getMonth(), now.getDate(), '00', '00', '00');

          if(aula.getTime() == nowData.getTime()){
            return 1;
          }

          return 0;
      },

      getAulasReposicao () {
        this.$http.get(`${this.url}/${this.idAluno}`).then(response => {
          this.aulas = response.data.dados;
        });
      },

      getTime (data_fim) {
        let end = data_fim.split(/[- :]/)
        let end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))
        let check = ((end_date.getTime() - new Date().getTime()) > 0)
        return true
      },

      ead (turma) {
        var ini = turma.data_inicio.split(/[- :]/)
        var end = turma.data_fim.split(/[- :]/)

        // Apply each element to the Date function
        var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]))
        var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]))

        if (this.id_role == 3) {
          this.$router.push({ name: 'eadAluno',
            params: {
              'ini': ini_date.getTime(),
              'end': end_date.getTime(),
              'turma': turma.id_turma_teorica
            } })
        } else if (this.id_role == 4) {
          this.$router.push({ name: 'eadInstrutor',
            params: {
              'ini': ini_date.getTime(),
              'end': end_date.getTime(),
              'turma': turma.id_turma_teorica
            } })
        }
      },

      biometria (idTurma) {
        let self = this
        self.$http
          .get(urlApi + `/getran/atualizar/turma/${idTurma}/biometria`)
          .then(function (response) {
            TurmasController.launchToast(
              'fa-check',
              response.data.dados,
              'top-center'
            )
          })
          .catch(function (error) {
            self.table.load = false
            TurmasController.launchToast(
              'fa-times',
              error.data.dados,
              'top-center'
            )
          })
      },

      faces (idTurma) {
        let self = this
        self.$http
          .get(urlApi + `/getran/atualizar/turma/${idTurma}/faces`)
          .then(function (response) {
            TurmasController.launchToast(
              'fa-check',
              response.data.dados,
              'top-center'
            )
          })
          .catch(function (error) {
            self.table.load = false
            TurmasController.launchToast(
              'fa-times',
              error.data.dados,
              'top-center'
            )
          })
      },

      registrarPresenca (turma) {
        var ini = turma.data_inicio.split(/[- :]/)
        var end = turma.data_fim.split(/[- :]/)
        //
        // Apply each element to the Date function
        var ini_date = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() - 30 * 60000)
        var end_date = new Date(new Date(end[0], end[1] - 1, end[2], end[3], end[4], end[5]).getTime() + 60 * 60000)
        var tolerancia = new Date(new Date(ini[0], ini[1] - 1, ini[2], ini[3], ini[4], ini[5]).getTime() + 20 * 60000)
        let now = new Date()
        let localTime = now.getTime();
        let localOffset = now.getTimezoneOffset() * 60000;
        let utc = localTime + localOffset;
        let offset = -3;
        let fortaleza = utc + (3600000*offset);
        let nowUtc = new Date(fortaleza);

        if(now.getTime() != nowUtc.getTime()){
          console.log("HORA LOCAL: " + now)
          console.log("HORA DE FORTALEZA: " + nowUtc)
          now = nowUtc
        }
        //
        if (ini_date > now || end_date < now) {
          PresencaController.launchToast('fa-times', 'Essa aula não está disponível!')
        } else {
            this.turma = turma
            this.processPhoto()
        }
      },

      processPhoto () {
        let self = this
        self.presenca = false
        navigator.mediaDevices
          .getUserMedia({ video: { width: 250, height: 250 } })
          .then(function (stream) {
            self.stream = stream
            document.getElementById('player').srcObject = stream
            self.$refs.photoModal.open()
          })
          .catch(function (err) {
            if (err.name == "AbortError") {
                // declarações para manipular exceções AbortError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Operação Interrompida!'.toUpperCase())

            } else if (err.name == "NotAllowedError") {
                // declarações para manipular exceções NotAllowedError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())

            } else if (err.name == "NotFoundError") {
                // declarações para manipular exceções NotFoundError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Nenhuma câmera encontrada!'.toUpperCase())

            } else if (err.name == "NotReadableError") {
                // declarações para manipular exceções NotReadableError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Não foi possível acessar sua câmera!'.toUpperCase())

            } else if (err.name == "OverconstrainedError") {
                // declarações para manipular exceções OverconstrainedError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Dispositivo inválido!'.toUpperCase())

            } else if (err.name == "SecurityError") {
                // declarações para manipular exceções SecurityError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'O sistema não possui permissão para acessar sua câmera! Cheque as permissões do sistema.'.toUpperCase())

            } else if (err.name == "TypeError") {
                // declarações para manipular exceções TypeError
                PresencaController.launchToast('fa-times', err)
                PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())

            } else {
              // declarações para manipular quaisquer exceções não especificadas
              PresencaController.launchToast('fa-times', err)
              PresencaController.launchToast('fa-times', 'Erro desconhecido!'.toUpperCase())

            }
            console.log(err)
          })
      },
      captureSnapshot () {
        let self = this

        var snapshotCanvas = document.getElementById('snapshot')
        snapshotCanvas
          .getContext('2d')
          .drawImage(document.getElementById('player'), 0, 0, 250, 250)
        document.getElementById('send').disabled = false
      },

      sendSnapshot () {
        let self = this

        self.$refs.photoModal.close()

        var data = {
          foto: document.getElementById('snapshot').toDataURL('image/jpeg'),
          cpf: localStorage.cpf
        }

        PresencaController.sendSnapshot(data, function (response) {
          var size = response.data.dados[1]
          var conf = response.data.dados[2]

          console.log('Confiança: ' + conf ** 2 / size)

          if ((conf ** 2 / size) > 70) {
            PresencaController.launchToast('fa-times', 'Foto inválida!')
            self.$refs.photoModal.open()
          } else {
            let role = ''

            if (self.id_role == 4) {
              role = 'ALUNO'
            } else if (self.id_role == 3) {
              role = 'INSTRUTOR'
            }

            let data = {
              entidade: role,
              id: localStorage.id,
              turma: self.turma.id_turma_teorica
            }

            self.$http.post(urlApi + '/ead/reposicao', data).then(function (response) {
              console.log()
              PresencaController.launchToast('fa-check', 'Sucesso!')

              let button = document.getElementById('push_' + self.turma.id_agrupamento)
              button.title = 'Entrar na sala!'
              button.disabled = false
              self.modalClosed()
            }).catch(function (error) {
              console.log(error)
              PresencaController.launchToast('fa-times', error.data.dados)
              console.log(error)
            })
          }
        })
      },

      push (dados) {
        let session = 'turma_' + dados.id_agrupamento
        let nome = localStorage.nome.split(' ')[0]
        let role = ''

        if (this.id_role == 4) {
          role = 'aluno'
        } else if (this.id_role == 3) {
          role = 'instrutor'
        }

        let str = btoa(btoa(btoa(`turma=${session}&nome=${nome}&tipo=${role}&schema=${localStorage.schema}&id=${localStorage.id}&url=${localStorage.url}`)))
        console.log(localStorage.url)

         window.open(`https://ead.novocfc.com.br/#/?${str}`)
        //window.open(`http://localhost:8083/#/?${str}`);
      },

      modalClosed (eventClose) {
        this.stream.getTracks().forEach(function (track) {
          track.stop()
        })
      },


    }
  }
</script>
